module.exports = __webpack_public_path__ + "static/media/Discord icon.8e23c962.svg";